<template>
  <div>

    <router-link
      :to="{name: 'master-customer-list'}"
      class="text-decoration-none text-white"
    >
      <b-button
        class="mb-1"
        variant="primary"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class="mr-75"
        />
        Kembali
      </b-button>
    </router-link>
    <b-card>
      <!-- required required Wajib diisi -->
      <!-- min:x min:3 Minimal x karakter -->
      <!-- max:x max:10 Maksimal x karakter -->
      <!-- email email Format email valid -->
      <!-- numeric numeric Hanya angka -->
      <!-- between:x,y between:1,10 Antara nilai x dan y -->
      <!-- confirmed confirmed:password Cocok dengan field lain -->
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <!-- Nama Pelanggan -->
            <b-col
              xl="6"
              md="12"
            >
              <b-form-group
                label="Nama Pelanggan"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukkan Nama Pelanggan"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>

              <!-- Phone -->
              <b-form-group
                label="No HP"
                label-for="category"
              >
                <validation-provider
                  #default="{ errors }"
                  name="phone"
                  rules="required"
                >
                  <b-input-group>
                    <!-- <b-input-group-prepend is-text>
                      +62
                    </b-input-group-prepend> -->
                    <cleave
                      id="phone"
                      v-model="phone"
                      class="form-control"
                      :raw="false"
                      :options="options.phone"
                      placeholder="81234567890"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>

              <!-- NPWP -->
              <b-form-group
                label="Email"
                label-for="email"
              >

                <b-form-input
                  id="email"
                  v-model="email"
                  placeholder="Masukkan email"
                />
              </b-form-group>
              <b-form-group
                label="Status Member"
                label-for="is_member"
              >
                <b-form-select
                  id="is_member"
                  v-model="is_member"
                  :options="memberOptions"
                />
              </b-form-group>
            </b-col>

            <!-- Alamat -->
            <b-col
              xl="6"
              md="12"
            >
              <b-form-group
                label="Alamat"
                label-for="address_line1"
              >
                <b-form-textarea
                  id="address_line1"
                  v-model="address_line1"
                />
              </b-form-group>

              <!-- Bank Akun -->
              <b-form-group
                label="Provinsi"
                label-for="province"
              >

                <b-form-input
                  id="province"
                  v-model="province"
                  placeholder="Masukkan Provinsi"
                />
              </b-form-group>

              <!-- Bank Name -->
              <b-form-group
                label="Kabupaten / Kota"
                label-for="city"
              >

                <b-form-input
                  id="city"
                  v-model="city"
                  placeholder="Masukkan Kabupaten / Kota"
                />
              </b-form-group>

              <!-- Bank Rek -->
              <b-form-group
                label="Kecamatan"
                label-for="subdistrict"
              >

                <b-form-input
                  id="subdistrict"
                  v-model="subdistrict"
                  placeholder="Masukkan Kecamatan"
                />

              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- Tombol Aksi -->
            <b-col
              md="12"
            >
              <b-button
                type="submit"
                variant="success"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Simpan
              </b-button>
              <b-button
                type="reset"
                variant="outline-secondary"
              >
                Reset
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer></b-card>

  </div>
</template>

<script>
import {
  BFormInput, BFormGroup, BRow, BCol, BButton, BCard, BForm, BFormTextarea, BInputGroup,
  BFormSelect,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// eslint-disable-next-line import/no-cycle
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BRow,
    BForm,
    BCol,
    BButton,
    BCard,
    BFormTextarea,
    BInputGroup,
    // BInputGroupPrepend,
    Cleave,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      customerId: null,
      name: null,
      address_line1: null,
      phone: null,
      email: null,
      village: null,
      subdistrict: null,
      city: null,
      is_member: null,
      memberOptions: [
        { value: 1, text: 'Member' },
        { value: 0, text: 'Non Member' },
      ],
      required,
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['Y', 'm', 'd'],
        },
        phone: {
          phone: true,
          phoneRegionCode: 'ID',
        },
        time: {
          time: true,
          timePattern: ['h', 'm', 's'],
        },
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
        },
        block: {
          blocks: [4, 3, 3],
          uppercase: true,
        },
        delimiter: {
          delimiter: '·',
          blocks: [3, 3, 3],
          uppercase: true,
        },
        customDelimiter: {
          delimiters: ['.', '.', '-'],
          blocks: [3, 3, 3, 2],
          uppercase: true,
        },
        prefix: {
          prefix: '+63',
          blocks: [3, 3, 3, 4],
          uppercase: true,
        },
      },
    }
  },
  computed: {},
  created() {
    this.$http.get(`/customer/${this.$route.params.id}`)
      .then(res => {
        this.customerId = res.data.customer.id
        this.name = res.data.customer.name
        this.phone = res.data.customer.phone
        this.address_line1 = res.data.customer.address_line1
        this.village = res.data.customer.village
        this.subdistrict = res.data.customer.subdistrict
        this.city = res.data.customer.city
        this.province = res.data.customer.province
        this.email = res.data.customer.email
        this.is_member = res.data.customer.is_member
      })
      .catch(() => {
        this.$bvToast.toast('Gagal mendapat data. Silakan Kembali', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })

        // this.$router.push({ name: 'apps-customer-list' })
      })
  },
  mounted() {
    // Mengambil ID dari params
    this.customerId = this.$route.params.id
  },
  methods: {
    submitProduct() {
      const payload = {
        id: this.customerId,
        name: this.name,
        address_line1: this.address_line1,
        phone: this.phone,
        email: this.email,
        province: this.province,
        city: this.city,
        subdistrict: this.subdistrict,
        is_member: this.is_member,
      }

      this.$http.put('/customer/update', payload)
        .then(() => {
          this.$bvToast.toast('Pelanggan berhasil diubah!', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
          // Reset redirect
          this.$router.push({ name: 'master-customer-list' })
        })
        .catch(() => {
          this.$bvToast.toast('Gagal mengubah Pelanggan.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitProduct()
        } else {
          this.$bvToast.toast('Lengkapi Data Sebelum Submit!', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        }
      })
    },
  },
}
</script>
